export const ABASTECIMENTO = 1;
export const TELEMETRIA = 2;
export const DESCARGA_NF = 3;
export const CONTROLE_DE_COTAS = 4;
export const SOBRAS_E_FALTAS = 5;
export const LUBRIFICACAO = 6;
export const MOTORISTA_ABASTECIMENTO = 7;
export const GERENCIA_ABASTECIMENTO = 8;
export const SAFRA_ABASTECIMENTO = 9;
export const CENTRO_CUSTO_ABASTECIMENTO = 10;
export const CAUSA_MANUTENCAO_LUBRIFICANTE = 11;
export const OPERACAO_ABASTECIMENTO = 12;
export const CONTRATO_ABASTECIMENTO = 13;
export const GEOLOCALIZACAO = 14;
export const LOCALIDADE_ABASTECIMENTO = 17;
export const FRENTISTA_ABASTECIMENTO = 18;
export const INTEGRACAO_ABASTECIMENTO = 19;
export const INTEGRACAO_LUBRIFICACAO = 20;
export const INTEGRACAO_TRANSFERENCIA = 21;
export const MODULO_ALARMES = 22;
export const SAP = 23;
export const BI = 24;
export const DESCARGA_TERMINAL = 25;
export const MODULO_CONSULTA_TOTALIZADOR = 29;
export const MODULO_AFERICAO_DVEC = 30;
export const CUSTOMIZACAO_TEREOS = 10000;
export const CUSTOMIZACAO_RAIZEN = 30000;
export const MODULO_20_GRAUS = 16;
export const COMPLEXIDADE_SENHA = 31;
export const MODULO_FERROVIA = 32;
export const TRR_CHILE = 33;
export const SKID = 34;
export const MODULONFE = 35;
export const MODULOFOTO = 36;
export const MODULO_CTF = 38;
export const MODULO_ARQUEACAO_AUTOMATICA = 39;
export const MODULO_DISPOSITIVO = 40;
export const MODULOTEO= 41;
export const MODULO_CUSTOMIZACAO_VLI = 50000;
export const MODULO_CUSTOMIZACAO_RUMO = 60000;
